import React, { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Routes, BrowserRouter, Route, Navigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

// Actions
import { logout } from "./actions/auth";

// Helpers
import LocationChange from './helpers/LocationChange';

// Components
import Login from "./components/login.component";
import Dashboard from "./components/Dashboard";
import StakeholdersList from "./components/StakeholdersList";
import Stakeholder from "./components/Stakeholder";
import Report from "./components/Report";
import Donations from "./components/Donations";
import Output from "./components/Output";
import NFCScanner from "./components/NFCScan";
import AziendeList from "./components/AziendeList";
import Azienda from "./components/Azienda";
import ProtectedRoute from "./components/ProtectedRoute";
import MainDashboardPage from "./components/MainDashboardPage";

const App = () => {
    const { user } = useSelector(state => state.auth);
    const dispatch = useDispatch();

    const logOut = () => {
        dispatch(logout());
    };

    const { admin } = useMemo(() => {
        if (!user) return { admin: false };
        return {
            admin: user.roles?.includes("ROLE_ADMIN"),
        };
    }, [user]);

    // Definisco se l'utente è quello dello scanner
    const isScannerUser = user?.username === "scannerNFC";

    return (
        <BrowserRouter>
            <LocationChange />
            
            <Routes>
                {/* 1. Rotta Home: Gestione Login/Redirect Iniziale */}
                <Route 
                    path="/" 
                    element={
                        !user ? (
                            <Login />
                        ) : isScannerUser ? (
                            <Navigate to="/scanner" replace />
                        ) : (
                            <Navigate to="/dashboard" replace />
                        )
                    } 
                />

                {/* 2. Rotta Scanner */}
                <Route 
                    path="/scanner" 
                    element={user ? <NFCScanner /> : <Navigate to="/" />} 
                />

                <Route element={<ProtectedRoute />}>
                    {/* 3. BLOCCO DASHBOARD 
                       Qui avviene la magia: se l'utente è scannerNFC e prova ad accedere 
                       a /dashboard (o qualsiasi figlia), viene rispedito a /scanner.
                       Altrimenti vede la Dashboard normale.
                    */}
                    <Route 
                        path="/dashboard" 
                        element={
                            isScannerUser ? (
                                <Navigate to="/scanner" replace />
                            ) : (
                                <Dashboard user={user} logOut={logOut} />
                            )
                        }
                    >
                        <Route index element={<MainDashboardPage admin={admin} />} />
                        <Route path="stakeholders" element={<StakeholdersList />} />
                        <Route path="stakeholders/add" element={<Stakeholder />} />
                        <Route path="stakeholders/:id" element={<Stakeholder />} />
                        <Route path="stakeholders/:id/edit" element={<Stakeholder v={true} />} />
                        <Route path="stakeholders/:id/azione" element={<Stakeholder panel={4} />} />
                        
                        <Route path="aziende" element={<AziendeList />} />
                        <Route path="aziende/add" element={<Azienda />} />
                        <Route path="aziende/:id" element={<Azienda />} />

                        <Route path="donazioni" element={<Donations />} />
                        <Route path="uscite" element={<Output />} />
                        <Route path="report" element={<Report />} />
                    </Route>
                </Route>

                {/* 4. Rotta Catch-all (*) */}
                <Route 
                    path="*" 
                    element={
                        !user ? (
                            <Navigate to="/" />
                        ) : isScannerUser ? (
                            <Navigate to="/scanner" replace />
                        ) : (
                            <Navigate to="/dashboard" replace />
                        )
                    } 
                />
            </Routes>
        </BrowserRouter>
    );
};

export default App;